import React from 'react'
import DocumentManagementHero from './DocumentManagementHero'
import CallToAction from '../../../../LandingSection/CallToAction'
import Footer from '../../../../Components/Footer'
import Header from '../../../../Components/Header'
import Challenge from './Challenge'
import OurSolution from './OurSolution'
import DocumentManagementTechSolutions from './DocumentManagementTechSolutions'

const DocumentManagementCaseStudyPage = () => {
  return (
    <>
      <Header bgColor="#242424"/>
      <div className="overflow-x-hidden w-full">
      <DocumentManagementHero />
      <DocumentManagementTechSolutions />
      <Challenge />
      <OurSolution />
      <CallToAction/>
              <Footer/>
      </div>
    </>
  )
}

export default DocumentManagementCaseStudyPage
